/**
 * Se crea una instacia de Vue para utilizarla comno puente de comunicaccion entre los
 * componentes y los infowindows components a traves de custom event $emit $on
 */
import Vue from "vue";
const BridgeInstance = new Vue();
export default BridgeInstance;
